var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03 21.77L16.35 15.7L31.04 19.66L17.84 25.96L3.03 21.77Z",
    fill: "#332044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.11 16.73L16.42 10.67L31.12 14.63L17.92 20.93L3.11 16.73Z",
    fill: "#B44654"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 12.05L16.35 6.53L29.77 10.15L17.77 15.87L4.25 12.05Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.39 6.99L28.52 10.26L17.73 15.41L5.51 11.95L16.39 6.99ZM16.32 6.07L3 12.14L17.81 16.33L31.01 10.03L16.32 6.07Z",
    fill: "#E69F6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/group1.f787dfe0b86ec2d49fa30fcdbe151565.svg";
export { ForwardRef as ReactComponent };